import styled from 'styled-components';
import { viewports } from 'app/shared/styles/_breakpoints';

import RenterProfileForm from 'app/shared/modules/RenterProfileForm';
import Text from 'app/shared/core/Text';

export const StyledRenterProfilePopup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 32px;

  /* Let PopupModal handle the sizing and padding */
  width: 100%;
  min-height: 0; /* Allow flex shrinking */

  @media ${viewports['md-and-up']} {
    /* Use a reasonable max-width that works with PopupModal */
    max-width: 420px;
    margin: 0 auto;
  }
`;

export const ModalTitle = styled(Text)`
  flex-shrink: 0; /* Don't shrink the title */
  font-weight: 700;
  padding-top: 16px;
  text-align: center;
`;

export const StyledRenterProfileForm = styled(RenterProfileForm)`
  /* Let the form take up available space and be scrollable if needed */
  flex: 1 1 auto;
  min-height: 0; /* Allow flex shrinking */
`;

export const ButtonFooter = styled.footer`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-shrink: 0; /* Don't shrink the button footer */
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px;
  background: white;
  border-top: 1px solid lightgray;
`;
